import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import styled from '@emotion/styled';

// components
import CardTemplates from '@components/_molecules/CardTemplates';
import TableLabel from './TableLabel';
import MaterialRow from './MaterialRow';

// constants

// type
import { QuotationSaleSelfGetSaleQuotationItemSelfDataType } from 'models/SupplementType';
import { returnNumberWithComma } from '@utils/regex';
import { parseItemDescription } from '@hooks/service/parseItemDescription';
import { useTranslation } from 'next-i18next';

type Props = {
  data: QuotationSaleSelfGetSaleQuotationItemSelfDataType[];
  itemIds: number[];
  setItemIds: Dispatch<SetStateAction<number[]>>;
};

const MaterialList = styled.div`
  margin-top: 16px;

  display: grid;
  row-gap: 16px;
`;

export default function SubmitMaterialCard({ data, itemIds, setItemIds }: Props) {
  const { t, i18n } = useTranslation('seller');
  const ko = i18n.language === 'ko';

  const won = ko ? '원' : ' KRW';
  // 견적 제출 품목 data 셋팅 -> 총계를 보여줘야 함으로 number형, string형 둘다 set
  const submitMaterial = useMemo(() => {
    return data?.map((row) => {
      if (!row.order_item) {
        return null;
      }
      const id = row.id;
      const { quantity, unit_price, item } = row.order_item;
      const total_price = quantity! * unit_price!;
      const product_type = row?(row.product?row.product.product_type : row.product_type) : 'ETC';
      return {
        item_id: id!,
        quantity,
        quantityString: returnNumberWithComma(quantity!),
        unit_price,
        unitPriceString: unit_price ? returnNumberWithComma(unit_price) + won : '',
        total_price,
        totalPriceString: returnNumberWithComma(total_price) + won,
        itemDescription: item ? parseItemDescription(item) : '',
        product_type: product_type,
        order_item:row.order_item
      };
    }).filter((row) => row !== null);
  }, [data, won]);

  // itemIds setting
  useEffect(() => {
    setItemIds(submitMaterial?.map((item) => item.item_id));
  }, [submitMaterial, setItemIds]);

  return (
    <CardTemplates title={t('reRequest.submitMaterialCard-title')}>
      {/* Table Label */}
      <TableLabel />
      {/* Table Label end */}

      <MaterialList>
        {submitMaterial?.map((item, idx) => {
          return (
            (item.order_item && <MaterialRow idx={idx} data={item} itemIds={itemIds} setItemIds={setItemIds} key={item.item_id} />)
          )
        })}
      </MaterialList>
    </CardTemplates>
  );
}
